module.exports = __webpack_public_path__ + "img/queue.7ba3f729.svg";